import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=6fedd768&scoped=true&"
import script from "./flow.vue?vue&type=script&lang=js&"
export * from "./flow.vue?vue&type=script&lang=js&"
import style0 from "./flow.vue?vue&type=style&index=0&id=6fedd768&prod&lang=css&"
import style1 from "./flow.vue?vue&type=style&index=1&id=6fedd768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fedd768",
  null
  
)

export default component.exports